import React, { useEffect } from 'react';
import { Alert, Typography } from '@mui/material';
import { getRemovedComponentMeta } from '../../utils/removedComponentTypes';

/**
 * Read-only notice for component types that no longer have an editor.
 */
export default function RemovedComponentNotice({
  componentType,
  setChildTemplateLoaded,
  compact = false,
}) {
  const meta = getRemovedComponentMeta(componentType);
  const displayName = meta?.displayName ?? componentType ?? 'Unknown component';

  useEffect(() => {
    setChildTemplateLoaded?.(true);
  }, [setChildTemplateLoaded]);

  return (
    <Alert severity="info" sx={{ m: compact ? 0 : 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
        {displayName} (removed)
      </Typography>
      <Typography variant="body2">
        This component type is no longer supported. The node stays on the canvas for
        reference, but it cannot be edited or added again. Remove it from the workflow
        if you no longer need it.
      </Typography>
    </Alert>
  );
}
